import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineEducationalForm extends TitleBase {
	private disciplineValue: string;
	private educationalFormValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.educationalFormValue = this.getFilterValue(ParameterType.EDUCATIONAL_FORM);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.EDUCATIONAL_FORM)
		);
	}

	protected getPageTitle(): string {
		return `${this.disciplineValue} ${this.educationalFormValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.educationalFormValue} ${this.titlePortalType} in the field of ${this.disciplineValue}`,
			' worldwide',
		);
	}
}
